import i18next from '@bonanza-social/i18n';
import en from './en.json';
import fr from './fr.json';

i18next.addResources('en', 'registration', en);
i18next.addResources('fr', 'registration', fr);

declare global {
  interface RegisteredLocales {
    registration: typeof en;
  }
}
